import React, { lazy, useEffect, useState } from "react";

// Libraries
import { Col, Container, Navbar, Row } from "react-bootstrap";
import { Link, Outlet, useNavigate } from "react-router-dom";

// Components
import {
  Header,
  HeaderCart,
  HeaderLanguage,
  HeaderNav,
  Menu,
  SearchBar,
  Topbar,
} from "../Components/Header/Header";
import FooterStyle01 from "../Components/Footers/FooterStyle01";
import HeaderToolbar from "../Components/Header/HeaderToolbar";
import NewHeader from "../Components/Header/new-header/NewHeader";
import SocialIcons from "../Components/SocialIcon/SocialIcons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import WhatsAppFloatingButton from "./ecd-pages/WhatsAppFloatingButton ";
import CartIcon from "../Components/Header/CartIcon";
// import CartDrawer from "./meldi-dham-pages/product/CartDrawer";
import LoginPage from "./meldi-dham-pages/auth-pages/LoginPage";
import { useDispatch } from "react-redux";
import { clearCart } from "../store/cartSlice";
import { toast } from "react-toastify";
import LogoutConfirmationModal from "./meldi-dham-pages/auth-pages/LogoutConfirmationModal";
const SideButtons = lazy(() => import("../Components/SideButtons"));

const iconData = [
  {
    color: "#828282",
    link: "https://youtube.com/@ramvadimeldimaa?si=wYNGALH9OX2ndK5M",
    icon: "fa-brands fa-youtube fs-6",
  },
  {
    color: "#828282",
    link: "https://youtube.com/@khunkhaarmeldimaabareja?si=z2Pva_8Nx3jaQ8Aw",
    icon: "fa-brands fa-youtube fs-6",
  },
  {
    color: "  rgb(245, 37, 165)",
    link: "https://www.instagram.com/@khunkhaar_meldi_maa_bareja",
    icon: "fab fa-instagram text-rgb(245, 37, 165)",
  },
  {
    color: "#184cbb",
    link: "https://www.facebook.com/@khunkhaar_meldi_maa_bareja/",
    icon: "fab fa-facebook-f text-[#184cbb]",
  },
];

const downloadApp = [
  {
    color: "#3DDC84",
    link: "https://play.google.com/store/apps/details?id=com.agm.meldidham_member_live&pcampaignid=web_share",
    icon: "fa-brands fa-android",
    title: "Android",
  },
  {
    color: "#000000",
    link: "https://apps.apple.com/us/app/bareja-dham/id6760822771",
    icon: "fa-brands fa-apple",
    title: "iOS",
  },
];

const ElementPage = (props) => {
  const { t, i18n } = useTranslation();
  const [showCart, setShowCart] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [customer, setCustomer] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const MEMBER_WEB = process.env.REACT_APP_MEMBER_WEB_URL;

  useEffect(() => {
    const session = localStorage.getItem("customer"); // ✅ sessionStorage
    setCustomer(session ? JSON.parse(session) : null);
  }, []);
  // -------------------------------------------------

  const [showModal, setShowModal] = useState(false);
  const handleLogout = () => {
    setShowModal(true);
  };
  const confirmLogout = () => {
    setShowModal(false);
    localStorage.removeItem("customer");
    localStorage.removeItem("checkoutAddress");
    dispatch(clearCart());
    navigate("/page/store", { replace: true });
    console.log("User logged out");
  };

  const cancelLogout = () => {
    setShowModal(false);
  };

  const handleOpenMemberSite = () => {
    window.open(`${MEMBER_WEB}`, "_blank");
  };

  const styles = {
    footerBar: {
      display: "flex",
      justifyContent: "center",
      gap: "40px",
      padding: "12px 10px",
      backgroundColor: "#fff",
      borderTop: "1px solid #e5e5e5",
      fontSize: "14px",
      fontWeight: 700,
    },
    link: {
      color: "#fff",
      textDecoration: "none",
    },
  };

  return (
    <>
      {/* Header Start */}
      <Header
        topSpace={{ desktop: true }}
        type="reverse-scroll"
        className="header-with-topbar bg-[#FF4F00] border-b border-[#0000001a] "
      >
        <Topbar className="home-business-topbar border-[#0000001a] md:px-0">
          {/* <Topbar className="home-business-topbar border-[#0000001a] sm:hidden md:px-0"> */}
          <Container>
            {/* <Container fluid> this is use full line toolbar */}
            <Row className="justify-between pl-[15px] lg:pr-[15px] items-center majer-project">
              <HeaderToolbar />
            </Row>
          </Container>
        </Topbar>
        <HeaderNav
          fluid="fluid"
          theme="light"
          // bg="white"
          menu="light"
          containerClass="sm:px-0 pe-0"
          className="px-[25px] py-[0px] md:pr-[10px] md:pl-0 px-0"
          style={{ backgroundColor: "#FF4F00" }}
        >
          <Col className="col-auto col-sm-6 col-lg-2 me-auto ps-lg-0">
            <Link
              aria-label="header logo"
              className="d-flex align-items-center"
              to="/"
            >
              <div className="">
                {/* Desktop & Laptop logo */}
                <img
                  className="default-logo img-fluid d-none d-md-block"
                  loading="lazy"
                  src="/assets/logo/barejadham1.png"
                  alt="logo"
                  style={{ maxWidth: "75px" }}
                />

                {/* Tablet logo */}
                <img
                  className="alt-logo img-fluid d-none d-sm-block d-md-none"
                  loading="lazy"
                  src="/assets/logo/barejadham1.png"
                  alt="logo"
                  style={{ maxWidth: "75px" }}
                />

                {/* Mobile logo */}
                <img
                  className="mobile-logo img-fluid d-block d-sm-none"
                  loading="lazy"
                  src="/assets/logo/barejadham1.png"
                  alt="logo"
                  style={{ maxWidth: "75px" }}
                />
              </div>
            </Link>
          </Col>
          <Col className="col-auto text-start hidden-xs font-size-0 !pl-[12px]" />
          <Navbar.Toggle className="order-last md:mx-[12px]">
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
            <span className="navbar-toggler-line"></span>
          </Navbar.Toggle>
          <Navbar.Collapse className="col-auto justify-end p-0">
            <Menu {...props} />
          </Navbar.Collapse>
          <button
            className="btn btn-danger bg-red-600 me-1 hover:bg-white hover:text-red-600 transition-colors"
            style={{ backgroundColor: "#e01313ff", color: "white" }}
            onClick={handleOpenMemberSite}
            // onClick={() => setShowLogin(true)}
          >
            Login
          </button>
          <LoginPage show={showLogin} onHide={() => setShowLogin(false)} />
          <LogoutConfirmationModal
            show={showModal}
            onConfirm={confirmLogout}
            onCancel={cancelLogout}
          />
        </HeaderNav>
      </Header>
      {/* Header End */}
      <Outlet />

      {/*  Footer Start */}
      {/* <FooterStyle01 theme="dark" className="bg-[#FF4F00] text-slateblue" /> */}

      <footer className="bg-[#FF4F00] text-white pt-3 mt-5 border-top border-dark">
        <div className="container">
          <Row className="align-items-start gy-4">
            {/* Logo Column */}
            <Col md={4} sm={12} className="text-center text-md-start">
              <Link
                aria-label="footer logo"
                className="d-inline-flex align-items-center"
                to="/"
              >
                <img
                  src="/assets/logo/barejadham1.png"
                  alt="Meldi Dham Logo"
                  loading="lazy"
                  className="img-fluid"
                  style={{ maxWidth: "250px" }}
                />
              </Link>
            </Col>

            {/* Contact Column */}
            <Col md={5} sm={12} className="text-start">
              <p className="text-uppercase fw-bold mb-4 fs-6 text-white">
                {/* Contact Us */} {t("menu.contact")}
              </p>
              <p className="mb-2 text-white">
                {t("contect_us")}
                {/* બારેજા ધામ વિષે અન્ય કોઈ જાણકારી તથા સલાહ-સૂચન માટે આ બે નંબર પર
                સંપર્ક કરો. */}
              </p>
              <p className="fw-semibold text-white">
                <i className="feather-phone-call me-2 text-white" />
                +91 82008 20261 | +91 84013 61024 <br />
                {/* <small className="text-white">(સેવક બારેજા ધામ)</small> */}
                <small className="text-white">( {t("conectwith")} )</small>
              </p>
            </Col>

            {/* Social Column */}
            <Col md={3} sm={12} className="text-md-end text-center pb-2">
              <p className="text-uppercase fw-bold mb-2 fs-6 text-white">
                {/* Follow Us */}
                {t("follow")}
              </p>
              <SocialIcons
                size="sm"
                theme="social-icon-style-01 mb-4"
                className="justify-md-end justify-end text-white"
                // iconColor={props.theme === "white" ? "white" : "white"}
                data={iconData}
              />
              <p className="mb-2 fs-6 fw-bold">{t("download_app")}</p>

              <div className="d-flex gap-3 text-3xl justify-md-end justify-end fw-bolder">
                {downloadApp.map((item, index) => (
                  <a
                    key={index}
                    href={item.link}
                    className="btn btn-sm text-white flex items-center gap-2 px-3 "
                    style={{ backgroundColor: item.color }}
                  >
                    <i className={`fs-5 ${item.icon}`}></i> {item.title}
                  </a>
                ))}
              </div>
            </Col>

            <WhatsAppFloatingButton />
          </Row>
        </div>
        <div
          className="d-flex justify-content-center align-items-center gap-3 py-2 border-top border-white text-white"
          style={{ flexWrap: "wrap", fontSize: "14px" }}
        >
          <Link
            to="/terms-condition"
            className="fw-bold uppercase"
            style={styles.link}
          >
            Terms & Condition
          </Link>

          <span>|</span>

          <Link
            to="/our-policy"
            style={styles.link}
            className="fw-bold uppercase"
          >
            Our Policy
          </Link>

          <span>|</span>

          <Link
            to="/cancellation-refund-policy"
            style={styles.link}
            className="fw-bold uppercase"
          >
            Cancellation & Refund Policy
          </Link>

          {/* <span>|</span> */}

          <span>
            © {new Date().getFullYear()} {t("reserved")}
          </span>

          {/* <span>|</span> */}

          <a
            href="https://agmetech.com"
            target="_blank"
            rel="noreferrer"
            className="text-white text-decoration-none"
          >
            {t("developed_by")}
          </a>
        </div>
      </footer>
      {/*  Footer End */}
    </>
  );
};

export default ElementPage;
